<template lang='pug'>
  .back-icon
    .row(@click='back')
      .svg-icon.chevron-left.left-arrow.svg
      span(v-t='"buttons.back"')
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('faq')

export default {
  computed: {
    ...mapState(['activeSection'])
  },
  methods: {
    back () {
      if (this.$route.name === 'faq-section-show') {
        this.$router.push({ name: 'faq' })
      } else if (this.$route.name === 'faq-article-show' && this.activeSection) {
        this.$router.push({ name: 'faq-section-show', params: { sectionId: this.activeSection } })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  .row {
    line-height: 20px;
    cursor: pointer;
    margin-bottom: 15px;
  }

  .left-arrow {
    height: 20px;
    width: 20px;
    margin-left: 5px;

    @include media-breakpoint-up(md) {
      margin-left: 10px;
    }
  }
</style>
